import { FormProvider, useForm } from 'react-hook-form';
import React, { useEffect, useState } from 'react';
import { GenericDialog } from 'app/components/Alerts/GenericDialog';
import { Grid, Typography } from '@mui/material';
import SearchGridWrapper from 'app/layout/pages/SearchGridWrapper';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { getFilterRequest, revalidateChipSelection } from '@AMIEWEB/GlobalSearch/helper';
import { gridStateActions, GridTag } from '@AMIEWEB/Common/Grid/GridStateManagement/GridState.redux';
import { globalSearchActions } from 'store/redux-store/global-search/slice';
import { SearchType } from 'app/models/GlobalSearch/GlobalSearch';
import { makeStyles } from 'tss-react/mui';
import { globalActions } from 'app/ApplicationRoot/Global.redux';
import { gridSelectionActions } from '@AMIEWEB/Common/Grid/GridSelection/GridSelection.redux';
import { OrdersSearchGrid } from './Search/OrdersSearchGrid';
import { OrdersSearchChips } from './Search/OrdersSearchChips';
import { OrdersSearchFilter } from './Search/OrdersSearchFilter';
import { placementDetailsAction } from 'store/redux-store/placement-details/slice';
import { selectUser } from 'oidc/user.selectors';
import { selectIsUpdatedOrderId, selectPlacementHeaderData } from 'store/redux-store/placement-details/selectors';
import { usePromiseTracker } from 'react-promise-tracker';
import { Cancel } from '@AMIEWEB/Common';
import { PromiseTrackerKeys } from 'app/constants/PromiseTrackerKeys';
import { eventChannel } from 'redux-saga';
import {
  ff_peformance_enhanced_placement_profile_page,
  ff_placement_check_for_classic_packets_in_ok_to_send_status,
  ff_placement_ui_peoplesoft_sync,
  ff_placement_ui_requirement_check,
} from 'app/constants/FeatureFlags/Placement/Keys';
import { placementSummaryConsolidatedStoreActions } from 'store/redux-store/placement-summary/consolidatedStoreSlice';
import { placementSummaryActions } from 'store/redux-store/placement-summary/slice';
import { pageAttributesActions } from '../PlacementDetails/Edit/store/placementPageAttributes.redux';
import { placementStatusAction } from 'store/redux-store/placement-status/slice';
import { placementDocumentsActions } from 'store/redux-store/placement-documents/slice';
import { useDecision } from '@optimizely/react-sdk';
import { ff_placement_ui_arbitration_agreement_grids } from 'app/constants/FeatureFlags/Global/keys';
import { selectGridState } from '@AMIEWEB/Common/Grid/GridStateManagement/GridState.selectors';
import { SkillSetSelection } from './Search/SkillSetSelection';
import { ff_margin_tool_placement_profile } from 'app/constants/FeatureFlags/MarginTool/Keys';

export const useStyles = makeStyles()(theme => ({
  searchDialogContainer: {
    minWidth: '1250px',
    minHeight: '560px',
  },
  marginApproveDialog: {
    minWidth: '440px',
    maxWidth: '440px'
  },
}));

type SortType = 'asc' | 'desc';

interface ISkillSetOption {
  ID: number;
  Description: string;
  DisciplineId: number;
  SpecialtyId: number;
}

export const ChangeOrderIDSearchDialog = props => {
  const { t } = useTranslation();
  const { classes } = useStyles();
  const dispatch = useDispatch();
  const [defaultOrderColumn] = useState<{ column: string; direction: SortType }>({
    column: 'orderId',
    direction: 'desc',
  });
  const { openSearchDialog, setOpenSearchDialog } = props;
  const [saveDisabled, setSaveDisabled] = useState<boolean>(true);
  const [skillSetSelectionDialog, setSkillSetSelectionDialog] = useState<{
    open: boolean;
    orderId: number;
    skillSetSelectionOptions: ISkillSetOption[];
    selectedSkillSet: ISkillSetOption;
  }>({ open: false, orderId: 0, skillSetSelectionOptions: null, selectedSkillSet: null });
  const [cancel, setCancel] = useState<boolean>(false);
  const [openMarginApproveDialog, setOpenMarginApproveDialog] = useState(false);
  const formMethods = useForm();
  const { handleSubmit } = formMethods;
  const placementHeaderDetails = useSelector(selectPlacementHeaderData);
  const { userInfo } = useSelector(selectUser);
  const isUpdatedOrderId = useSelector(selectIsUpdatedOrderId);
  const gridState = useSelector(selectGridState);
  const { promiseInProgress } = usePromiseTracker({ area: PromiseTrackerKeys.placements.updateOrderId, delay: 0 });
  const [enablePeopleSoft] = useDecision(ff_placement_ui_peoplesoft_sync);
  const [requirementCheckFlag] = useDecision(ff_placement_ui_requirement_check);
  const [checkClassicPacketInOkToSendFlag] = useDecision(ff_placement_check_for_classic_packets_in_ok_to_send_status);
  const [arbitrationAgreementFlag] = useDecision(ff_placement_ui_arbitration_agreement_grids);
  const [performanceOptimizedPageLoad] = useDecision(ff_peformance_enhanced_placement_profile_page);
  const [featureFlagMarginTool] = useDecision(ff_margin_tool_placement_profile);
  const onSubmitClick = () => {
      const payload = {
        requestPayLoad: {
          placementId: placementHeaderDetails?.placementId,
          orderId: skillSetSelectionDialog?.orderId,
          travelerId: placementHeaderDetails?.candidate.id,
          companyId: placementHeaderDetails?.brandId,
          disciplineId: skillSetSelectionDialog?.selectedSkillSet?.DisciplineId,
          specialtyId: skillSetSelectionDialog?.selectedSkillSet?.SpecialtyId,
          employeeId: userInfo?.employeeId,
        },
        marginToolFlagEnabled:featureFlagMarginTool?.enabled
      };

      const resultChannel:any = eventChannel(emitter => {
        dispatch(
          placementDetailsAction.updateOrderIdForPlacement({
            payload,
            meta: { resultChannel: emitter },
          }),
        );

        return () => {};
      });
      resultChannel.take(result => {
        if (result.success) {
          dispatch(placementSummaryConsolidatedStoreActions.reset());
          dispatch(placementDetailsAction.reset());
          dispatch(placementSummaryActions.reset());
          dispatch(pageAttributesActions.reset());
          dispatch(placementStatusAction.reset());
          dispatch(placementDocumentsActions.reset());
          dispatch(
            placementDetailsAction.onInitAction({
              placementId: placementHeaderDetails?.placementId,
              peoplesoftEnabled: enablePeopleSoft?.enabled,
              requirementCheckFlagEnabled: requirementCheckFlag.enabled,
              checkClassicPacketInOkToSendEnabled: checkClassicPacketInOkToSendFlag?.enabled,
              arbitrationAgreementFlagEnabled: arbitrationAgreementFlag?.enabled,
              isPerformanceOptimized: performanceOptimizedPageLoad?.enabled,
            }),
          );
        } else if (!result.success && result.hasApprovedScenario) {
          setOpenMarginApproveDialog(true);
        }
      });
  };

  const handleSaveAction = () => {
    skillSetSelectionDialog?.skillSetSelectionOptions?.length > 1 && !skillSetSelectionDialog?.open
      ? setSkillSetSelectionDialog({ ...skillSetSelectionDialog, open: true })
      : onSubmitClick();
  };

  const handleCancel = (reason?) => {
    if (reason !== 'backdropClick') {
      if (skillSetSelectionDialog !== null) setCancel(true);
      else setOpenSearchDialog(false);
      dispatch(globalSearchActions.reset());
    }
  };

  const noAction = () => {
    setCancel(false);
  };
  const yesAction = () => {
    setCancel(false);
    setOpenSearchDialog(false);
    setSkillSetSelectionDialog(null);
  };
  const onApplyFilter = (values, newFilterChips?) => {
    const filters = getFilterRequest(values, newFilterChips);
    dispatch(
      gridStateActions.setFilterAttributes({
        filterObject: Object.entries(values),
        selectedChipFilters:
          newFilterChips || revalidateChipSelection(values, gridState?.filterAttributes?.selectedChipFilters || []),
      }),
    );
    dispatch(gridStateActions.setPageNumber(1));
    dispatch(
      globalSearchActions.getSearchResults({
        searchType: SearchType.order,
        keyword: '',
        pageNumber: 1,
        pageSize: 250,
        sortedColumn: defaultOrderColumn,
        filter: filters || {},
        translation: t,
      }),
    );
    setSaveDisabled(true);
  };

  useEffect(() => {
    if (isUpdatedOrderId) {
      setOpenSearchDialog(false);
      dispatch(globalSearchActions.reset());
      dispatch(placementDetailsAction.setIsUpdatedOrderId(false));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isUpdatedOrderId]);

  useEffect(() => {
    if (openSearchDialog) {
      dispatch(gridStateActions.setGrid(GridTag.ChangeOrderIDGrid));
      setSkillSetSelectionDialog(null);
      return () => {
        dispatch(gridStateActions.reset());
        dispatch(globalSearchActions.reset());
        dispatch(globalActions.closeBanner());
        dispatch(
          gridSelectionActions.setGridSelections({
            selectedData: [],
          }),
        );
      };
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [openSearchDialog]);
  return (
    <>
      <GenericDialog
        variant={'blue'}
        classes={{
          paper: classes.searchDialogContainer,
        }}
        open={openSearchDialog}
        disablePortal
        draggable
        disableEscapeKeyDown
        dialogTitleProps={{
          text: t('placement.OrderChangeID.dialogTitle'),
          closeButton: true,
          expandable: true,
        }}
        dialogActions={[
          {
            text: t('global.button.cancel'),
            variant: 'contained',
            color: 'tertiary',
            onClick: handleCancel,
          },
          {
            text: t('global.button.save'),
            variant: 'contained',
            disabled: saveDisabled,
            onClick: handleSaveAction,
          },
        ]}
        onClose={(e, reason) => {
          handleCancel(reason);
        }}
      >
        <FormProvider {...formMethods}>
          <form onSubmit={handleSubmit(filter => onApplyFilter(filter))}>
            <Grid spacing={3} container>
              <Grid item xs={12}>
                {
                  <SearchGridWrapper
                    filters={<OrdersSearchFilter onApplyFilter={onApplyFilter} />}
                    chips={<OrdersSearchChips onApplyFilter={onApplyFilter} />}
                    table={
                      <OrdersSearchGrid
                        saveDisabled={saveDisabled}
                        setSaveDisabled={setSaveDisabled}
                        skillSetSelectionDialog={skillSetSelectionDialog}
                        setSkillSetSelectionDialog={setSkillSetSelectionDialog}
                        {...props}
                      />
                    }
                    loading={promiseInProgress}
                    tableMinHeight={460}
                  />
                }
              </Grid>
            </Grid>
          </form>
        </FormProvider>
      </GenericDialog>
      {cancel && <Cancel openDialog={cancel} handleConfirmAction={yesAction} handleCancelAction={noAction} />}
      {skillSetSelectionDialog?.open && (
        <SkillSetSelection
          skillSetSelectionDialog={skillSetSelectionDialog}
          setSkillSetSelectionDialog={setSkillSetSelectionDialog}
          onSubmitClick={onSubmitClick}
        />
      )}
      {openMarginApproveDialog && (
        <GenericDialog
          open={openMarginApproveDialog}
          disablePortal
          draggable
          disableEscapeKeyDown
          classes={{
            paper: classes.marginApproveDialog,
          }}
          dialogTitleProps={{
            text: t('placement.OrderChangeID.approvedMarginScenarioHeader'),
          }}
          dialogActions={[
            {
              text: t('global.button.ok'),
              variant: 'contained',
              onClick: () => {
                setOpenMarginApproveDialog(false);
              },
            },
          ]}
        >
          <Typography>{t('placement.OrderChangeID.approvedMarginScenarioErrorMessage')}</Typography>
        </GenericDialog>
      )}
    </>
  );
};
